var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.178,
    height: 22.712,
    viewBox: "0 0 28.178 22.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-checkmark",
    "data-name": "Icon ion-checkmark",
    d: "M31.75,9,14.25,29l-7.5-7.5",
    transform: "translate(-5.159 -7.413)",
    fill: "none",
    stroke: "#d7664a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOrange);
export default __webpack_public_path__ + "static/media/check_orange.b901660de9be280a74e6420a2d5e45c8.svg";
export { ForwardRef as ReactComponent };